import { IClinicianFilterType, useTranslation } from "hhn-commons";
import { CLINICIAN_ROLES } from "@home-health-notify/domain";
import Chips from "../../../../common/Chips/Chips";
import { ClinicianDisciplineChipsWrapper } from "./AdvanceSearchList.style";

interface ClinicianDisciplineChipsProps {
  onSelectDiscipline: (clinicianRole: CLINICIAN_ROLES) => void;
  selectedDiscipline: CLINICIAN_ROLES;
  options: IClinicianFilterType[];
}

const DisciplineChips = Chips<CLINICIAN_ROLES>;

function ClinicianDisciplineChips({
  onSelectDiscipline,
  selectedDiscipline,
  options,
}: ClinicianDisciplineChipsProps) {
  const { t } = useTranslation();
  const tNAdvanceSearch = (key: string) => t(key, { ns: "advanceSearch" });

  return (
    <ClinicianDisciplineChipsWrapper>
      <DisciplineChips
        onSelectChip={onSelectDiscipline}
        selectedChip={selectedDiscipline}
        label={tNAdvanceSearch("discipline")}
        options={options}
        name="clinician-discipline"
      />
    </ClinicianDisciplineChipsWrapper>
  );
}

export default ClinicianDisciplineChips;
